import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, forwardRef } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { ConfigurationService } from '../../../services/configuration.service';
import { AlertService } from '../../../services/alert.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'ztsi-payment-type-select',
	templateUrl: './ztsi-payment-type-select.component.html',
	styleUrls: ['./ztsi-payment-type-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiPaymentTypeSelectComponent),
			multi: true
		}
	]
})
export class ZtsiPaymentTypeSelectComponent implements OnInit {
	types: KeyValuePair[] = [
		{ key: 'CASH', value: 'Cash' },
		{ key: 'CHECK', value: 'Check' }
	];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _configurationService: ConfigurationService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._configurationService.getPaymentTypes().subscribe(response => {
			if (response.length != undefined) {
				this.types = response;
			}
			else {
				console.log('Unable to load client selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-payment-type-select/ztsi-payment-type-select.component.ts